import { render, staticRenderFns } from "./CartProductListSkeleton.vue?vue&type=template&id=2494e752"
import script from "./CartProductListSkeleton.vue?vue&type=script&lang=js"
export * from "./CartProductListSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports